var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LocationDialog',{attrs:{"is-open":_vm.isOpen,"location":_vm.location,"title":_vm.getFormattedLocation(_vm.location),"actionName":"Save Changes","loading":_vm.isLoading},on:{"close":_vm.close,"submit":_vm.handleEdit}})
}
var staticRenderFns = []

export { render, staticRenderFns }